import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateWechatState } from "../../../redux/slice/wechatSlice";
import { Popup, Selector, Button, Toast } from 'antd-mobile';
import api from "../../../api";
import { isWxOrAli } from "../../../utils/env";
import "./style.less";

const Recharge = (props) => {
  const { wallet, walletId, visible, setVisible, payCallback } = props

  // 判断当前是微信 or 支付宝
  const aliOrWx = isWxOrAli();

  const [chargePrice, setChargePrice] = useState()
  const [giftAmount, setGiftAmount] = useState(0)

  const wechatState = useSelector((state) => state.wechat)
  const dispatch = useDispatch()

  // 处理ios异常url
  let url = wechatState.ios ? wechatState.url : window.location.href;

  // 获取全局wx对象
  const wx = window.wx;

  // 充值赠送金额
  const chargePriceOptions = wallet?.type === 1 ?
    [
      { label: '30元', value: '3000', giftAmount: 200 },
      { label: '50元', value: '5000', giftAmount: 500 },
      { label: '100元', value: '10000', giftAmount: 1200 },
    ]
    :
    [
      { label: '50元', value: '5000', giftAmount: 500 },
      { label: '100元', value: '10000', giftAmount: 1200 },
    ];

  //价格变动时，变更赠送金额
  const handlePriceChange = async (price) => {
    setChargePrice(price)

    chargePriceOptions.forEach((item) => {
      if (item.value === price) {
        setGiftAmount(item.giftAmount)
      }
    })
  }

  const handlePayClick = async () => {
    if (!chargePrice) {
      return
    }

    let payChannel = 0;
    if (aliOrWx === 'wechat') {
      payChannel = 1;
    } else if (aliOrWx === 'alipay') {
      payChannel = 2;
    } else {
      return
    }

    const params = {
      walletId,
      amount: parseInt(chargePrice),
      payChannel // 微信 or 支付宝
    }
    const resp = await api.userWalletRecharge(params)

    if (resp.data?.code === 0) {
      const payParams = resp.data.data;

      if (payChannel === 1) {
        // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#58
        wx.chooseWXPay({
          appId: payParams.appId,
          timestamp: payParams.timeStamp,
          nonceStr: payParams.nonceStr,
          package: payParams.package,
          signType: payParams.signType,
          paySign: payParams.paySign,
          success: function (res) {
            Toast.show({ content: '充值成功' })
            setVisible(false)
            payCallback()
          }
        })
      } else if (payChannel === 2) {
        document.getElementById("alipay-form-recharge").innerHTML = payParams;
        document.forms[0].submit();
      }
    } else {
      Toast.show({ content: '支付失败，请稍后再试' })
    }
  }

  // 微信初始化配置
  // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html#4
  const wxConfig = (realAuthUrl) => {
    api.wechatJsapiSignature({ url: realAuthUrl }).then((res) => {
      let signature = res.data.data;
      signature.jsApiList = ['scanQRCode', 'chooseWXPay'];
      signature.openTagList = ['wx-open-launch-weapp'];

      wx.config(signature);

      wx.ready(function () {
        // IOS环境特殊处理
        if (wechatState.ios) {
          const newWechatState = {
            url: wechatState.url,
            ios: wechatState.ios,
            loaded: wechatState.loaded,
            iosReady: true
          }
          dispatch(updateWechatState(newWechatState))
        }
      });

      wx.error(function (res) {
        // alert("error : " + JSON.stringify(res))
      });
    });
  }

  // 触发刷新页面
  useEffect(() => {
    if (aliOrWx === 'wechat') {
      // 非ios平台每次都需要config
      if (!wechatState.ios || !wechatState.iosReady) {
        wxConfig(url)
      }
    }
  }, [walletId])



  if (!walletId) {
    return undefined
  }

  return (
    <Popup
      visible={visible}
      showCloseButton
      onClose={() => {
        setVisible(false)
      }}
      bodyStyle={{
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        minHeight: '40vh',
      }}
    >
      <div className="price-select-wrapper">
        <Selector
          style={{
            '--border-radius': '5px'
          }}
          columns={3}
          options={chargePriceOptions}
          onChange={v => {
            if (v.length) {
              handlePriceChange(v[0])
            }
          }}
        />
      </div>

      <div className="gift-wrapper">
        <div>充值赠送 <span className="gift-amount">{giftAmount / 100}</span> 元</div>
      </div>

      <div className="pay-button">
        <Button block color="success" onClick={handlePayClick} >支 付</Button>
      </div>

      <div id="alipay-form-recharge"></div>
    </Popup>
  )
}

export default Recharge